import { setElementInnerHTML, setElementValue } from "../lib/utils.js"

class FFSelect extends HTMLElement {
  DOM: {
    prompt: HTMLElement | null
    promptText: HTMLElement | null
    list: HTMLElement | null
    input: HTMLInputElement | null
    options: NodeListOf<HTMLLIElement>
  }

	constructor(){
		super()
    this.DOM = {
			prompt: this.querySelector('.js-prompt'),
			promptText: this.querySelector('.js-promptText'),
			list: this.querySelector('ul'),
			input: this.querySelector('input'),
			options: this.querySelectorAll('li'),
		}
		this.events();
	}
	onClick (){
		this.setAttribute('tabindex', "1");
		this.focus();
		if( this.classList.contains('active') ){
			this.classList.remove('active');
			this.DOM.list?.classList.remove('active');
		}else{
			this.classList.add('active');
			this.DOM.list?.classList.add('active');
		}
	}

	onBlur (){
		this.classList.remove('active')
		this.DOM.list?.classList.remove('active');
	}

	optionClick(e: MouseEvent){
    const target = e.target
    if( !(target instanceof HTMLElement) ) return
		const value = target.getAttribute('data-value');
		const string = target.innerHTML;
    setElementValue(this.DOM.input, value || "")
    setElementInnerHTML(this.DOM.promptText, string)
		const event = new Event('optionChange');
		this.dispatchEvent(event);
	}
	events(){
		this.addEventListener('click', this.onClick.bind(this) );
		this.addEventListener('blur', this.onBlur.bind(this) );

		for (let i = this.DOM.options.length - 1; i >= 0; i--) {
			this.DOM.options[i].addEventListener('click', this.optionClick.bind(this) );
		}
	}
}
customElements.define('ff-select', FFSelect);